<template>
    <div class="web-links">
        <ul class="am-cf">
            <li class="am-text-truncate" v-for="(item,index) in list" :key="index">
                <a :href="item.sub_title"   target="_blank">
                {{item.title}}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data(){
        return{
            list:[]
        }
    },
    created(){
        this.getList({typeId:'port31',rowNum:'6'}).then(result=>{
            this.list=result 
        })
    }
}
</script>

<style lang="scss">
.web-links{
    margin-top: 20px;
    padding-left: 160px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    height: 68px;
    background-image: url(~@/assets/images/bg8.png);
    ul{
        li{
            float: left;
            font-size: 14px;
            text-align: center;
            font-family: myfont;
            font-size: 16px;
            height: 68px;
            line-height: 68px;
            margin-right: 12px;
            color: $primary;
            &:hover{
                text-decoration: underline;
            }
        }
    }
}
</style>
